export default __webpack_public_path__ + "static/media/MissionEllis.54b6d687.png";